import Nav_cn from './Nav_cn'


function CnPillar1({match}) {
    let selectedPil="pillar ";
    let pillarHeading="";
    let pillar1Text="";
//    console.log(match.params.iso);
      selectedPil += " health-first";
      pillarHeading = "Health First";
      pillar1Text="When health systems collapse, deaths from the outbreak itself can quickly be exceeded by deaths from preventable or treatable conditions, no longer managed by a failing health system. It is therefore crucial to maintain essential lifesaving health services even while addressing the pandemic. The UNDS prioritized support to countries to maintain essential health services and the systems that support them. The UNDS mobilized around several global health milestone and repurposed a significant proportion of its portfolio on ensuring essential services are maintained and health systems strengthened to prepare for recovery.";
      return(
        <>
        <Nav_cn active="p1" iso={match.params.iso} />
        <div className={selectedPil}>
                  <PillarStart text={pillar1Text} pilHeading={pillarHeading} />
                  <div className="customcontainer">
                    <TopKeyFigureSection active="p1" />
                    <Pillar1IndicatorSection heading="People Accessing Vaccination, Maternal Health and Nutrition Programmes." indiNum="1" rowChartHeading="People Supported by Subgroup 2021" />
                    <Pillar1IndicatorSection heading="Health Facilities Supported (Immunization)" indiNum="2" kfHeading="Health Facilities" rowChartHeading="Health Facilities Supported by Subgroup 2021" />
                    <Pillar1IndicatorSection heading="Protecting Health Systems" indiNum="3" kfHeading="" rowChartHeading="" />
                    <Pillar1IndicatorSection heading="Health Workers Receiving UN Support" indiNum="4" kfHeading="Health Workers" rowChartHeading="Health Workers Supported by Subgroup 2021" />
                  </div>
                  <TableSection />
        </div>
        </>
      );

}

function TableSection()
{
  return(
    <div className="white-background">
      <div className="customcontainer">
          <div className="customrow">
              <div className="col-md-12">
                  <div className="title">
                      <div className="funded"></div>
                      <div className="text pillar">&nbsp;</div>
                  </div>
              </div>
              <table id="table" className="table table-hover"></table>
          </div>
      </div>
  </div>
  )
}

function PillarStart({text,pilHeading}){
    return (
      <div className="customcontainer">
                    <div className="topContent"><p>{text}</p></div>
                    <div className="customrow">
                        <div className="col-md-12">
                            <h1 className="pillar-title">
                                {pilHeading}
                            </h1>
                        </div>
                    </div>
                </div>
    )
  }

function TopKeyFigureSection({active})
{
      return(
        <div className="customrow">
          <div className="col-md-12">
            <div className="pillar1-blocks">
              <TopKeyFigure heading="MATERNAL HEALTH" div_id="1" />
              <TopKeyFigure heading="VACCINATION PROGRAMMES " div_id="2" />
              <TopKeyFigure heading="NUTRITION PROGRAMMES " div_id="3" />
            </div>
          </div>
        </div>
      )
}

function TopKeyFigure({heading, div_id})
{
  let divNAid="top-number"+div_id+"NA";
  let divID="top-number"+div_id;
  return(
    <div className="pillar-block">
      <div className="header">
          <div className="text text-center">
              {heading}
          </div>
      </div>
      <div className="body">
          <div className="counter text-center">
              <span id={divNAid}></span>
              <span id={divID}></span>
          </div>
      </div>
  </div>
  )
}


function IndKeyFigure({heading,div_id,unit})
{
//   console.log(div_id);
  return(
    <>
      <div className="counter text-center">
        <span id={div_id} className="kf-number"></span>
      </div>
      <div className="title" style={{textAlign: 'center'}}>
          <div className="text">{heading}</div>
      </div>
    </>
  )
}


function Pillar1IndicatorSection({heading,indiNum,kfHeading,rowChartHeading}){
    let indDivID="Ind1."+indiNum;
    let kfDivID="number"+indiNum;
    let qrtChartID="";
    let rowChartID="";
    let qrtChartContainerID="";
    let qrtNAContainerID="";
    let qrtNoteContainerID="";
    let rowChartContainerID="";
    let rowNAContainerID="";
    if(indiNum==="1")
    {
      qrtChartID="chart1-1."+indiNum;
      rowChartID="chart2-1."+indiNum;
      qrtChartContainerID="quater"+indiNum;
      rowChartContainerID="indicator"+indiNum;
      qrtNAContainerID="1."+indiNum+"chart1NA";
      qrtNoteContainerID="1."+indiNum+"chart1Note";
      rowNAContainerID="1."+indiNum+"chart2NA";
      return(
        <div id={indDivID} className="customrow">
          <div className="pillar health-first">
              <div className="customcontainer">
                  <div className="customrow">
                      <div className="col-md-12">
                          <h1 className="indicator-title">
                              {heading}
                          </h1>
                      </div>
                  </div>
              </div>
          </div>
          <div id="kf1.1" className="col-md-2">
            <div className="funded">
              <div className="body">
                <div className="burger">
                    <div>&nbsp;</div>
                    <div>&nbsp;</div>
                </div>
                <IndKeyFigure heading="Maternal Health" div_id="number1a" unit="" />
                <IndKeyFigure heading="Vaccination Programmes" div_id="number1b" unit="" />
                <IndKeyFigure heading="Nutrition Programmes " div_id="number1c" unit="" />
              </div>
            </div>
          </div>
          <div id={qrtChartID} className="col-md-5">
            <div className="funded">
                <div className="title">
                    <div className="text">Overall Progress</div>
                </div>
                <div className="content">
                    <div id={qrtChartContainerID}>
                    </div>
                    <div id={qrtNoteContainerID} style={{textAlign: 'center',fontSize:'10px'}}>Note: This chart showing overall progress of 2020 and 2021.</div>
                    <div id={qrtNAContainerID} className="title" style={{textAlign: 'center', display: 'none'}}>
                        <div className="kf-number" style={{paddingTop: '70px'}}>N/A</div>
                    </div>
                </div>
            </div>
          </div>
          <div id={rowChartID} className="col-md-5">
              <div className="funded">
                  <div className="title">
                      <div className="text">{rowChartHeading}</div>
                  </div>
                  <div className="content">
                      <div id={rowChartContainerID}>
                      </div>
                      <div id={rowNAContainerID} className="title" style={{textAlign: 'center', display: 'none'}}>
                          <div className="kf-number" style={{paddingTop: '70px'}}>N/A</div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      );
    }
      else
      {
        if(indiNum==="2" || indiNum==="4")
        {
          qrtChartID="chart1-1."+indiNum;
          rowChartID="chart2-1."+indiNum;
          qrtChartContainerID="quater"+indiNum;
          rowChartContainerID="indicator"+indiNum;
          qrtNAContainerID="1."+indiNum+"chart1NA";
          qrtNoteContainerID="1."+indiNum+"chart1Note";
          rowNAContainerID="1."+indiNum+"chart2NA";
      
          return(
            <div id={indDivID} className="customrow">
              <div className="pillar health-first">
                  <div className="customcontainer">
                      <div className="customrow">
                          <div className="col-md-12">
                              <h1 className="indicator-title">
                                  {heading}
                              </h1>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-md-2">
                <div className="funded">
                  <div className="body">
                    <div className="burger">
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </div>
                    <IndKeyFigure heading={kfHeading} div_id={kfDivID} unit="" />
                  </div>
                </div>
              </div>
              <div id={qrtChartID} className="col-md-5">
                <div className="funded">
                    <div className="title">
                        <div className="text">Overall Progress</div>
                    </div>
                    <div className="content">
                        <div id={qrtChartContainerID}>
                        </div>
                        <div id={qrtNoteContainerID} style={{textAlign: 'center',fontSize:'10px'}}>Note: This chart showing overall progress of 2020 and 2021.</div>
                        <div id={qrtNAContainerID} className="title" style={{textAlign: 'center', display: 'none'}}>
                            <div className="kf-number" style={{paddingTop: '70px'}}>N/A</div>
                        </div>
                    </div>
                </div>
              </div>
              <div id={rowChartID} className="col-md-5">
                  <div className="funded">
                      <div className="title">
                          <div className="text">{rowChartHeading}</div>
                      </div>
                      <div className="content">
                          <div id={rowChartContainerID}>
                          </div>
                          <div id={rowNAContainerID} className="title" style={{textAlign: 'center', display: 'none'}}>
                              <div className="kf-number" style={{paddingTop: '70px'}}>N/A</div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
          );
        }
          else
          return (
            <div id="Ind1.3" className="customrow">
              <div className="pillar health-first">
                  <div className="customcontainer">
                      <div className="customrow">
                          <div className="col-md-12">
                              <h1 className="indicator-title">
                                  Protecting Health Systems
                              </h1>
                          </div>
                      </div>
                  </div>
              </div>
  
              <div className="col-md-12">
                  <div className="pillar1-3-blocks">
                      <div className="pillar-block">
                          <div className="header">
                              <div className="text text-center">
                                  CORE ESSENTIAL HEALTH SERVICES
                              </div>
                          </div>
                          <div className="body">
                              <div className="counter text-center">
                                  <span id="top-number1-3a">No</span>
                                  <span id="top-number1-3a-dumy" style={{display: 'none'}}></span>
                              </div>
                          </div>
                      </div>
                      <div className="pillar-block">
                          <div className="header">
                              <div className="text text-center">
                                  HEALTH SECTOR POLICIES IMPLEMENTED
                              </div>
                          </div>
                          <div className="body">
                              <div className="counter text-center">
                                  <span id="top-number1-3b">No</span>
                                  <span id="top-number1-3b-dumy" style={{display: 'none'}}></span>
                              </div>
                          </div>
                      </div>
                      <div className="pillar-block">
                          <div className="header">
                              <div className="text text-center">
                                  MULTISECTORAL MENTAL HEALTH <br />AND PSYCHOSOCIAL SUPPORT
                              </div>
                          </div>
                          <div className="body">
                              <div className="counter text-center">
                                  <span id="top-number1-3c">No</span>
                                  <span id="top-number1-3c-dumy" style={{display: 'none'}}></span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          )
      }
  
  }



export default CnPillar1;